import { ColorEnum } from '@/constants/color'
import { selectedPriceColor } from '@/features/pos/components/ProductConfigurationModal/parts/OptionGroup/parts/OptionItem/constants'
import { useAnimatedTextColorStyle } from '@/features/pos/components/ProductConfigurationModal/parts/OptionGroup/parts/OptionItem/hooks/useAnimatedTextColorStyle'
import { Color } from '@/features/pos/components/ProductConfigurationModal/parts/OptionGroup/parts/OptionItem/types'
import AnimatedTypography from '@/features/ui/typography/animated'
import { FC } from 'react'
import { createStyleSheet, useStyles } from 'react-native-unistyles'

interface PriceProps {
    children: string
    selected: boolean
    disabled?: boolean
    color: Color
}

const Price: FC<PriceProps> = ({ children, selected, disabled, color }) => {
    const { styles } = useStyles(stylesheet, { disabled })

    const animatedTextColor = useAnimatedTextColorStyle(selected, {
        unselected: ColorEnum.JET_500,
        selected: selectedPriceColor[color],
    })

    return (
        <AnimatedTypography.Description
            font="medium"
            size="small"
            numberOfLines={1}
            style={[styles.price, !disabled && animatedTextColor]}
        >
            {children}
        </AnimatedTypography.Description>
    )
}

const stylesheet = createStyleSheet({
    price: {
        userSelect: 'none',
        variants: {
            disabled: {
                true: {
                    color: ColorEnum.GRAY_600,
                },
            },
        },
    },
})

export default Price
